import { createSelector } from 'reselect';

const selectSponsoredTextOffers = state => state.sponsoredTextOffers;

const selectSponsoredTextOffersByNamespace = ({ sponsoredTextOffers }, namespace = 'default') => {
  const { namespaceDefaults } = sponsoredTextOffers;
  return sponsoredTextOffers[`namespace-${namespace}`] || namespaceDefaults;
};

export const selectSponsoredTextOffersConfig = createSelector(
  selectSponsoredTextOffers,
  sponsoredTextOffers => sponsoredTextOffers.config,
);

export const makeSelectSponsoredTextOffersData = () => (
  createSelector(
    selectSponsoredTextOffersByNamespace,
    ({ data }) => data,
  )
);

export const makeSelectSponsoredTextOffersDataToDisplay = () => (
  createSelector(
    selectSponsoredTextOffersByNamespace,
    ({ data }) => data.slice(0, 5),
  )
);

export const makeSelectSponsoredTextOffersIsLoading = () => (
  createSelector(
    selectSponsoredTextOffersByNamespace,
    ({ isLoading }) => isLoading,
  )
);

export const makeSelectSponsoredTextOffersIsLoaded = () => (
  createSelector(
    selectSponsoredTextOffersByNamespace,
    ({ isLoaded }) => isLoaded,
  )
);
